export enum AssignmentSourceEnum {
    CUSTOMER = '3122c909-b5b3-40ce-8a02-6c9bb0aebec8',
    TASK = 'c57c9358-4ace-41b7-af69-a5caed50345b',
    OPPORTUNITY = '207bfb06-7d07-4150-a500-00b234d04abd',
    ACTIVITY = '8954d2ee-fba1-48e6-939b-74b44622dabf'
}

